import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, concatMap } from 'rxjs/operators';
import AppState from '../../state';
import {
  CleanRelease,
  LoadReleaseSuccess,
  StartRelease,
  UpdateField,
} from '../action-creators';
import { START_RELEASE, CLEAN_RELEASE, LOAD_RELEASE_SUCCESS } from '../actions';
import { Action } from 'redux';
import { ReleaseStore } from '../../../../../../common/types/release/release-store';
import { ReleaseRegion } from '../../../../../../common/types/release/release-region';

export const updateStoresAndRegionsEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, LoadReleaseSuccess | CleanRelease | StartRelease>(
      LOAD_RELEASE_SUCCESS,
      CLEAN_RELEASE,
      START_RELEASE
    ),
    filter(
      (action) =>
        !('release' in action) ||
        !action.release.stores?.length ||
        !action.release.regions?.length
    ),
    withLatestFrom(state$),
    concatMap(([action, state]) => {
      const actions: Action[] = [];

      if (!('release' in action) || !action.release.stores?.length) {
        if (state.categories.lists.platform?.length) {
          actions.push(
            new UpdateField<'stores'>(
              'stores',
              state.categories.lists.platform.map(
                (e) => e.metadata as ReleaseStore
              )
            )
          );
        }
      }

      if (!('release' in action) || !action.release.regions?.length) {
        if (state.categories.lists.region?.length) {
          actions.push(
            new UpdateField<'regions'>(
              'regions',
              state.categories.lists.region.map(
                (e) => e.metadata as ReleaseRegion
              )
            )
          );
        }
      }

      return actions;
    })
  );
